(() => {
  const page = window.location.pathname.split('/').filter(Boolean).pop();
  const main = document.getElementById('MainContent');
  if (!main) return;
  const title = main.querySelector('h1')?.textContent.trim();
  if (page === 'contact-us') {
    main.querySelectorAll('.rte h1').forEach((heading) => {
      const replacement = document.createElement('h2');
      replacement.className = heading.className;
      replacement.append(...heading.childNodes);
      heading.replaceWith(replacement);
    });
  }
  const formPages = ['become-a-dealer', 'damage-warranty-claims'];
  if (!formPages.includes(page) && page !== 'store-locator') return;
  function repairFrame(frame) {
    if (page === 'store-locator' && frame.id === 'dealer-locator-frame') frame.title = title;
    if (!formPages.includes(page) || !frame.classList.contains('hs-form-iframe')) return;
    frame.title = title;
    try {
      const formDocument = frame.contentDocument;
      if (!formDocument?.head || formDocument.getElementById('origins-form-accessibility')) return;
      const style = formDocument.createElement('style');
      style.id = 'origins-form-accessibility';
      style.textContent = '.hs-button.primary, input[type="submit"] { background: #71112d !important; border-color: #71112d !important; color: #fff !important; min-height: 44px; } .hs-button.primary:focus-visible, input[type="submit"]:focus-visible { outline: 3px solid #121212 !important; outline-offset: 3px; }';
      formDocument.head.append(style);
    } catch (error) {
      console.warn('Embedded form styling requires an update from the form provider.');
    }
  }
  main.querySelectorAll('iframe').forEach(repairFrame);
  main.addEventListener('load', (event) => {
    if (event.target instanceof HTMLIFrameElement) repairFrame(event.target);
  }, true);
  new MutationObserver((records) => {
    for (const record of records) for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node instanceof HTMLIFrameElement) repairFrame(node);
      node.querySelectorAll('iframe').forEach(repairFrame);
    }
  }).observe(main, { childList: true, subtree: true });
})();
